import {
  SETTINGS_SET_AVG_DATAPOINT,
  SETTINGS_SET_DATAPOINT,
  SETTINGS_SET_LOADING,
  SETTINGS_SET_DATAPOINT_PENDING,
  SETTINGS_SET_AUTOMATIC_ACTIONS,
  SETTINGS_SET_MODIFIED_VALUES,
  SETTINGS_SET_RESPONSE,
  SETTINGS_SET_BULLETS
} from "../actions/settings.actions";
import { INITIALIZE_STORE } from "../actions/manager.actions";

const initialState = {
  loading: {},
  pending: {},
  datapoint: {},
  avg: {},
  modifiedSettings: {
    teamColors: {},
    homeTimeZone: null,
    automaticOutlierApproval: null,
    playersAppPermission: null,
    preferredDateFormat: null,
    acwrLowerLimit: null,
    acwrUpperLimit: null,
    chronicIncludesAcute: null,
    acwrAcuteWindow: null,
    acwrChronicWindow: null,
    topSpeedPercThreshold: null,
  },
  bullets: null,
  teamSettingsResponse: null,
  automaticActions: { triggers: [] },
  error: null
}

export const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_SET_LOADING:
      return {
        ...state,
        loading: { ...state.loading, ...action.data },
      };
    case SETTINGS_SET_DATAPOINT_PENDING:
      return {
        ...state,
        pending: { ...state.pending, ...action.data },
      };
    case SETTINGS_SET_DATAPOINT:
      return {
        ...state,
        datapoint: action.data,
      };
    case SETTINGS_SET_AVG_DATAPOINT:
      return {
        ...state,
        avg: action.data,
      };
    case SETTINGS_SET_AUTOMATIC_ACTIONS:
      return {
        ...state,
        automaticActions: action.data,
      };
    case SETTINGS_SET_RESPONSE:
      return {
        ...state,
        teamSettingsResponse: action.data,
      };
    case SETTINGS_SET_MODIFIED_VALUES:
      return {
        ...state,
        modifiedSettings: { ...state.modifiedSettings, ...action.data},
      };
    case SETTINGS_SET_BULLETS:
      return {
        ...state,
        bullets: action.data,
      };
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
